import { api } from "roboflex-thalamus-request-handler";
import { ProductModel } from "../model/ProductModel";

export default {
  async getProducts() {
    let rawData = await api.get("produto");
    let products = rawData.data.map((e) => ProductModel.fromJson(e));

    return products;
  },

  async getProductsByTypeIds(ids) {
    let rawData = await api.post("produto-filtrar", { tipo: ids });
    let product = rawData.data.map((e) => ProductModel.fromJson(e));

    return product;
  },
  async getStructure(id) {
    const rawData = await api.get(`estrutura/produto/${id}`);

    if (!Array.isArray(rawData.data)) {
      return [];
    }

    return rawData.data.map((e) => ProductModel.fromJson(e));
  },
};
